import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { onMounted, ref } from 'vue';
import axios from 'axios';

/********************************
 *********** MAPLIBRE ***********
 *******************************/
import maplibregl from 'maplibre-gl';
import 'maplibre-gl/dist/maplibre-gl.css';
import markerImg from "@/assets/Icons/perforadora.png"

/********************************
 ********** CONSTANTES **********
 *******************************/
import { APIS_KPI, APIS_MAP, APIS_TOPOLOGY, APIS_DRIVE } from '@/constants/apis';
import { TOKEN } from '@/constants/labels';

/********************************
 ********** COMPONENTS **********
 *******************************/
import MapDialog from '@/components/RAOS/MapDialogRAOS.vue';




export default /*@__PURE__*/_defineComponent({
  __name: 'MapRAOS',
  setup(__props) {

const showSheet = ref(false);
const mouseX = ref(0);
const mouseY = ref(0);
const finalIP = ref('')
const finalLatency = ref('');
const finalUptime = ref('');
const finalBandWidth = ref('');
const finalLost = ref('')
const showMAP = ref(false)


const finalTXArray   = ref<any[]>([]);
const finalTXObject   = ref<any>({'features': [], "type": ''});

let map: maplibregl.Map;
const mapContainer = ref<HTMLDivElement | null>(null);

const postPORTItems = async (tipo:string, latitud:number, longitud:number, color:string, valor:string, index:number, fecha:string, uptime:string, latency: string, ip: string, bandwidth: string, lost:string, name:string) => {
    let finalITEM = {                        
            "type": "Feature",
            "properties": {
                "level": 0,
                "name": name,
                "height": 40,
                "base_height": 0,
                "color": color,
                "center": [longitud,latitud],
                "valor": valor,
                "fecha" : fecha,
                "uptime": uptime,
                "latency": latency,
                "bandwidth": bandwidth,
                "lost": lost,
                "ip": ip
            },
            "geometry": {
                "coordinates": [longitud,latitud],
                "type": "Point"
            },
            'id': index 
    }
    if(tipo.toUpperCase() === 'TX')       { finalTXArray.value.push(finalITEM) }
    // if(tipo.toUpperCase() === 'RX')       { finalRXArray.value.push(finalITEM) }
}

const setSourceAndLayer = async (source:string, alldata:any, layer:string) => {
    const mySource = map.getSource(source);
    if(mySource === undefined){ 
        map.addSource(source, { 'type': 'geojson', 'data': alldata});
        map.addLayer({
            'id': layer,
            'type': 'symbol',
            'source': source,
            'layout':{
                 'icon-image': 'custom-marker',
                 "text-field": ["get", "name"],  // toma el campo "title" de tu GeoJSON
                "text-font": ["Open Sans Bold"],
                "text-size": 12,
                "text-offset": [0, 3.5], // desplaza el texto debajo del icono
                "text-anchor": "top"
            },
            paint: {
                "text-color": "#FFFFFF"
            }
        });


        map.on('mouseenter', layer, (e:any) => {
            map.getCanvas().style.cursor = 'pointer';
            
            showSheet.value = true;
            mouseX.value = e.clientX + 60;
            mouseY.value = e.clientY + 60;
        });

        map.on('mousemove', layer, (e: any) => {
            map.getCanvas().style.cursor = 'pointer';

            // Para que se mueva con el mouse
            mouseX.value = e.point.x + 60;
            mouseY.value = e.point.y + 60;
            finalIP.value = `IP: ${e.features[0].properties.ip}`;
            finalLatency.value = `${e.features[0].properties.latency}`;
            finalUptime.value = `${e.features[0].properties.uptime}`;
            finalBandWidth.value = `${e.features[0].properties.bandwidth}`;
            finalLost.value = `${e.features[0].properties.lost}`;
        });
        
        map.on('mouseleave', layer, () => {
            showSheet.value = false;
            finalIP.value = ``;
            finalLatency.value = ``;
            finalUptime.value = ``;
            finalBandWidth.value = ``;
            finalLost.value = ``;
        });
    }
}

const clearLayerSource = async (layer:string, source:string) => {
    if(map.getLayer(layer)) { map.removeLayer(layer); }
    if(map.getSource(source)) { map.removeSource(source); }
}

// const watchLayer = (selectedVar: Ref<boolean>, type: string, source: string, finalObject: Ref<any>, layer: string) => {
//     watch(selectedVar, (state) => {
//         if (state) {
//             setSourceAndLayer(source, finalObject.value, layer);
//         } else {
//             clearLayerSource(layer, source);
//         }
//     });
// }; 


const POSITIONS = [
  [-20.9760, -68.7200],
  [-20.9729, -68.7049],
  [-20.9698, -68.7138],
  [-20.9667, -68.7009],
  [-20.9636, -68.7076],
  [-20.9805, -68.6989],
  [-20.9835, -68.6979],
  [-20.9705, -68.6289],
]

async function getAllInfoIntoMap(){
    axios.get(APIS_DRIVE.value.getRajantGPS, { headers: { "Authorization": `Bearer ${TOKEN}` } }).then(async (response) => {
        response.data.forEach((item:any) => {
            finalITEMS.value[item.ip].fecha = item.fecha;
            finalITEMS.value[item.ip].latitud = item.latitud;
            finalITEMS.value[item.ip].longitud = item.longitud;
        })

        Object.entries(finalITEMS.value).forEach(([ip, item]:any) => {
            // console.log('item', item.tipo)
            if(item.tipo && item.tipo.toUpperCase() === 'PERFORADORA'){
                const finalLatitud = item.latitud??(-20.9760);
                const finalLongitud = item.longitud??(-68.7200);
                const finalEBandWidth = item.bandwidth??0
                const finalELatency = item.latency??0
                const finalELost = item.lost??0

                postPORTItems('TX', finalLatitud, finalLongitud, ``, `IP: ${ip}`,1,`${item.fecha}`,`${item.uptime}`,`${finalELatency}`,`${item.ip}`, `${finalEBandWidth}`,`${finalELost}`, item.name);
            }
        });

        finalTXObject.value = { "features" : finalTXArray.value, type : "FeatureCollection" };
        await setSourceAndLayer('SourceTX',finalTXObject.value,'LayerTX');
        
        await clearLayerSource('LayerRX','SourceRX');


    })
}

const finalITEMS = ref<any>({})

async function  getAllOperabilityLastDay() {
    await axios.get(APIS_TOPOLOGY.value.getAllOpLastDay, { headers: { "Authorization": `Bearer ${TOKEN}` } }).then((response) => {
        const items = response.data;
        items.forEach((item:any) => {
            const totalUptime = item.ok + item.alert + item.alarm + item.down;
            const uptime = `${(((item.ok + item.alert + item.alarm) / totalUptime)*100).toFixed(2)}%`;

            const NotDown = item.ok + item.alert + item.alarm ;
            const lost = `${((item.down / NotDown)*100).toFixed(2)}%`

            if(!finalITEMS.value[item.ip]) {
                finalITEMS.value[item.ip] = {}
            }
            finalITEMS.value[item.ip].ip = item.ip;
            finalITEMS.value[item.ip].name = item.name;
            finalITEMS.value[item.ip].uptime = uptime;
            finalITEMS.value[item.ip].lost = lost;
        })
    })
}

async function  getAllLatencyLastMinute() {
    await axios.get(APIS_KPI.value.getAllLatency, { headers: { "Authorization": `Bearer ${TOKEN}` } }).then((response) => {
        const items = response.data;
        items.forEach((item:any) => {
            finalITEMS.value[item.ip].tipo = item.tipo
            finalITEMS.value[item.ip].latency = item.latencia.toFixed(2)
            // }
        })
    })
}

async function  getAllBandWidth() {
    await axios.get(APIS_MAP.value.getAllBandWidth,{ headers: { "Authorization": `Bearer ${TOKEN}` } }).then((response) => {
        const items = response.data;
        items.forEach((item:any) => {
            const finalBandWidth = JSON.parse(item.bandwidth??'{ Tx : -1, Rx : -1 }')
            finalITEMS.value[item.ip].bandwidth = finalBandWidth.Rx
        })
    })
}


        

onMounted(async() => {
    map  = new maplibregl.Map({
        container: mapContainer.value as HTMLDivElement,
        center: [-110.34328166666666, 30.964732],
        zoom: 14,
        pitch: 40,
        bearing: 30,
        style: 'https://api.maptiler.com/maps/satellite/style.json?key=6JWVt6LFaY22nquimZpF',
    });
    showMAP.value = true;

    const img = new Image(80, 80);

    img.onload = () => {
    map.addImage("custom-marker", img);
    };

    img.src = markerImg;

    await getAllOperabilityLastDay();
    await getAllLatencyLastMinute();
    await getAllBandWidth();
    await getAllInfoIntoMap();
    


    map.addControl(new maplibregl.NavigationControl());

})

return (_ctx: any,_cache: any) => {
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_row, { class: "ma-0" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: "12",
          class: "pa-0"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_sheet, {
              width: "100%",
              color: "transparent",
              class: "pa-6"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  ref_key: "mapContainer",
                  ref: mapContainer
                }, null, 512)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (showSheet.value)
      ? (_openBlock(), _createBlock(MapDialog, {
          key: 0,
          color: "background",
          style: _normalizeStyle([{ top: mouseY.value + 'px', left: mouseX.value + 'px' }, {"position":"fixed","z-index":"9"}]),
          hexaTitle1: finalBandWidth.value,
          hexaTitle2: `${finalLatency.value}ms`,
          hexaTitle3: finalLost.value,
          hexaTitle4: finalUptime.value,
          ip: finalIP.value
        }, null, 8, ["style", "hexaTitle1", "hexaTitle2", "hexaTitle3", "hexaTitle4", "ip"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})